import { useCallback, useState } from 'react';
import useDebounce from './use-debounce';
import {
  FILTER_DEBOUNCE_MILLISECONDS,
  FILTER_MINIMUM_CHARACTERS,
} from '../utils/constants';

const useDropdownFilter = () => {
  const [filterText, setFilterText] = useState('');
  const debouncedFilter = useDebounce(filterText, FILTER_DEBOUNCE_MILLISECONDS);
  const filterQuery =
    debouncedFilter.length >= FILTER_MINIMUM_CHARACTERS
      ? debouncedFilter
      : undefined;
  const onFilter = useCallback(
    (e: { filter: string }) => setFilterText(e.filter),
    [],
  );
  return { filterQuery, onFilter };
};

export default useDropdownFilter;
